module.exports = __webpack_public_path__ + "static/media/has_containers_half.977ef4e3.svg";